(function (root, factory) {
  const sets = factory();
  if (typeof module === "object" && module.exports) module.exports = sets;
  if (root) root.BulkColorRefillSets = sets;
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  "use strict";

  const tiers = [
    { id: "kit_24", count: 24, additions: [
      "A4", "A6", "A7", "B3", "B5", "B8", "C3", "C5", "C8", "D6", "D7", "D9",
      "E2", "E4", "F5", "G1", "G5", "G7", "H1", "H2", "H3", "H4", "H5", "H7"
    ] },
    { id: "kit_48", count: 48, additions: [
      "A10", "A11", "A13", "B12", "C2", "C6", "C7", "C10", "C11", "C13", "D3", "D13",
      "D15", "D18", "D19", "D21", "E3", "E7", "E8", "F8", "F13", "G8", "G9", "G13"
    ] },
    { id: "kit_72", count: 72, additions: [
      "A3", "B7", "B10", "B14", "B17", "B18", "B19", "B20", "C16", "D2", "D8", "D11",
      "D12", "D14", "D16", "D20", "E1", "E5", "E12", "E13", "F7", "F10", "G2", "G3"
    ] },
    { id: "kit_96", count: 96, additions: [
      "A14", "D5", "E6", "E9", "E10", "E11", "E14", "E15", "F1", "F2", "F3", "F4",
      "F6", "F9", "F11", "F12", "F14", "G14", "G17", "H6", "M5", "M6", "M9", "M12"
    ] },
    { id: "kit_120", count: 120, additions: [
      "A1", "A5", "A8", "A9", "A12", "A15", "B1", "B2", "B4", "B6", "B11", "B13",
      "B15", "B16", "C1", "C4", "C9", "C14", "C15", "C17", "D1", "D17", "G6", "H12"
    ] },
    { id: "all", count: 221, additions: [
      "A2", "A16", "A17", "A18", "A19", "A20", "A21", "A22", "A23", "A24", "A25", "A26",
      "B9", "B21", "B22", "B23", "B24", "B25", "B26", "B27", "B28", "B29", "B30", "B31",
      "B32", "C12", "C18", "C19", "C20", "C21", "C22", "C23", "C24", "C25", "C26", "C27",
      "C28", "C29", "D4", "D10", "D22", "D23", "D24", "D25", "D26", "E16", "E17", "E18",
      "E19", "E20", "E21", "E22", "E23", "E24", "F15", "F16", "F17", "F18", "F19", "F20",
      "F21", "F22", "F23", "F24", "F25", "G4", "G10", "G11", "G12", "G15", "G16", "G18",
      "G19", "G20", "G21", "H8", "H9", "H10", "H11", "H13", "H14", "H15", "H16", "H17",
      "H18", "H19", "H20", "H21", "H22", "H23", "M1", "M2", "M3", "M4", "M7", "M8",
      "M10", "M11", "M13", "M14", "M15"
    ] }
  ];

  const compareCodes = (left, right) => left.localeCompare(right, "en", { numeric: true });
  let accumulated = [];
  return tiers.map((tier) => {
    accumulated = [...accumulated, ...tier.additions].sort(compareCodes);
    return Object.freeze({ id: tier.id, count: tier.count, codes: Object.freeze([...accumulated]) });
  });
});
